/*
 * dontAllowBackButton removes the back-functionality for pages that include the js-dont-go-back class.
 * Generally placed on the body of the extra-info page.
 *
 * GDL Requirements
 * - This facilitates GDL's wish to not let the user 'go back' once they've submitted an order.
 */

const dontAllowBackButton = () => {
  if ($('.js-dont-go-back').length === 0) {
    return;
  }

  window.history.pushState(null, null, document.URL);
  window.addEventListener('popstate', () => {
    window.history.pushState(null, null, document.URL);
  });
};

export default dontAllowBackButton;
